<template>
  <div>
    <b-overlay
      :show="isLoading"
      variant="transparent"
      opacity="0.99"
      blur="5px"
      rounded="sm"
    >
      <div class="d-flex align-items-center justify-content-between pb-1">
        <h4>ตั้งค่า PGPRO</h4>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="primary"
          class="btn-icon"
          @click="getLogs"
          pill
        >
          <feather-icon icon="FileIcon" /> ประวัติ เปิด/ปิด
        </b-button>
      </div>
      <b-row>
        <b-col md="6">
          <b-card>
            <b-row match-height>
              <b-form-checkbox
                name="check-button"
                switch
                :value="1"
                :unchecked-value="0"
                @change="toggleAllGames()"
                v-model="toggleAll"
              >
                เปิดทุกเกม AMB
              </b-form-checkbox>
            </b-row>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card>
            <b-row match-height>
              <b-form-checkbox
                name="check-button"
                switch
                :value="2"
                :unchecked-value="0"
                @change="toggleAllGames()"
                v-model="toggleAll"
              >
                เปิดทุกเกม PG PRO
              </b-form-checkbox>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <transition name="fade">
        <b-card>
          <b-row match-height>
            <b-col
              sm="4"
              md="3"
              lg="2"
              v-for="item in pgproList"
              :key="item.id"
            >
              <b-card
                no-body
                class="border overflow-hidden"
                style="border-radius: 16px; position: relative"
              >
                <div
                  v-if="
                    item.pgpro_status === 1 ||
                    item.amb_status === 1 ||
                    item.pgai_status === 1
                  "
                  :style="{
                    position: 'absolute',
                    top: '10px',
                    right: '0',
                    backgroundColor:
                      item.setting_game === 2
                        ? 'red'
                        : item.setting_game === 1
                        ? 'blue'
                        : 'green',
                    color: 'white',
                    padding: '4px 8px',
                    borderTopLeftRadius: '4px',
                    borderBottomLeftRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    zIndex: 10,
                  }"
                >
                  {{
                    item.setting_game === 1
                      ? "AMB"
                      : item.setting_game === 2
                      ? "PG PRO"
                      : "PG AI"
                  }}
                </div>

                <img
                  class="w-100 h-100"
                  :src="item.img"
                  style="object-fit: cover"
                />

                <div class="mt-1 text-truncate px-1 pb-1">
                  <h6>{{ item.name }}</h6>

                  <b-form-select
                    @change="PGProchangeStatus(item)"
                    v-model="item.setting_game"
                    :options="getFilteredOptions(item)"
                    placeholder="ประเภทบัญชี"
                  />
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </transition>
    </b-overlay>

    <b-modal
      id="modal-primary"
      ok-only
      ok-title="ตกลง"
      v-model="ModalLogs"
      centered
      title="PGPRO Logs"
      size="lg"
    >
      <b-card-text>
        <b-table :responsive="true" hover :fields="fields" :items="items">
          <template #cell(index)="data">
            {{ perPage * (currentPage - 1) + data.index + 1 }}
          </template>
          <template #cell(status)="data">
            <div v-if="data.item.status === 1">
              <b-badge class="badge-glow"> ใช้ AMB </b-badge>
            </div>
            <div v-if="data.item.status === 2">
              <b-badge variant="success" class="badge-glow">
                ใช้ PG PRO
              </b-badge>
            </div>
            <div v-if="data.item.status === 3">
              <b-badge variant="warning" class="badge-glow">
                ใช้ PG AI (สำรอง)
              </b-badge>
            </div>
          </template>
          <template #cell(created_at)="data">
            {{ time(data.item.created_at) }}
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <b-form-group
            label="Per Page"
            label-cols="8"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
              @change="getLogs"
            />
          </b-form-group>

          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
              @input="getLogs"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormCheckbox,
  BRow,
  BCol,
  BModal,
  BFormGroup,
  BFormSelect,
  BPagination,
  BTable,
  BCard,
  BCardBody,
  BOverlay,
  BButton,
  BBadge,
} from "bootstrap-vue";
import moment from "moment-timezone";

export default {
  components: {
    BFormCheckbox,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormSelect,
    BPagination,
    BTable,
    BCard,
    BCardBody,
    BOverlay,
    BButton,
    BBadge,
  },
  data: () => ({
    pgproList: [],
    isLoading: false,
    toggleAll: 0,
    ModalLogs: false,
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 10,
    currentPage: 1,
    gamestatus: [
      { value: 0, text: "ปิด" },
      { value: 1, text: "AMB" },
      { value: 2, text: "PG PRO" },
      { value: 3, text: "PG AI" },
    ],
    fields: [
      { key: "index", label: "ลำดับ" },
      { key: "username", label: "ผู้ใช้" },
      { key: "name", label: "ชื่อเกม" },
      { key: "status", label: "สถานะ" },
      { key: "created_at", label: "วันที่สร้าง" },
    ],
    items: [],
  }),
  mounted() {
    this.getDataPgproAll();
    this.getDataPgpro();
  },
  methods: {
    time(date) {
      return moment(date).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm:ss");
    },
    async getLogs() {
      try {
        const { data } = await this.$http.get(`/pgpro/logs`, {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
          },
        });

        this.items = data.items;
        this.totalRows = data.totalRows;
        this.ModalLogs = true;
      } catch (error) {
        console.error(error);
      }
    },
    toggleAllGames() {
      this.isLoading = true;

      const payload = {
        game_status: this.toggleAll,
      };
      this.$http
        .post(`/pgpro/changeStatusAll_new`, payload)
        .then((response) => {
          if (response.data.success) {
            this.getDataPgpro();
            this.isLoading = false;
            this.Success(response.data.mes);
          } else {
            this.SwalError(response.data.mes);
            this.isLoading = false;
          }
          this.getDataPgproAll();
        });
    },
    Success(mes) {
      this.$swal({
        icon: "success",
        title: `<h3 style="color: #141414">${mes}</h3>`,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    SwalError(mes) {
      this.$swal({
        icon: "error",
        title: `<h3 style="color: #141414">${mes}</h3>`,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    },
    async PGProchangeStatus(item) {
      this.isLoading = true;
      try {
        await this.$http.post(`/pgpro/changeStatus_new`, item);
        this.getDataPgpro();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getDataPgproAll() {
      this.isLoading = true;
      try {
        const { data } = await this.$http.get(`/pgpro/statusallgames_new`);
        this.toggleAll = Number(data.game_status);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getFilteredOptions(item) {
      const options = [];
      if (item.amb_status === 1) {
        options.push({ value: 1, text: "AMB" });
      }
      if (item.pgpro_status === 1) {
        options.push({ value: 2, text: "PG PRO" });
      }
      return options;
    },
    async getDataPgpro() {
      this.isLoading = true;
      try {
        const { data } = await this.$http.get(`/pgpro/gamelist`);
        this.pgproList = data.Data;
        const gamestatusOptions = [];

        if (data.Data.some((item) => item.amb_status === 1)) {
          gamestatusOptions.push({ value: 1, text: "AMB" });
        }
        if (data.Data.some((item) => item.pgpro_status === 1)) {
          gamestatusOptions.push({ value: 2, text: "PG PRO" });
        }
        if (data.Data.some((item) => item.pgai_status === 1)) {
          gamestatusOptions.push({ value: 3, text: "PG AI" });
        }
        this.gamestatus = gamestatusOptions;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
